import { ToolbarElement } from './ToolbarElement'

const imagePanelTemplate = `
<div class="toolbar-image-url-row">
  <div class="box">
    <input type="text" placeholder="image url" />
  </div>
  <div class="button done" data-name="done"></div>
  <div class="button close" data-name="close"></div>
</div>
`

export class ToolbarImageElement extends ToolbarElement {
  public entryElement = document.createElement('div')
  public overlayElement: HTMLDivElement
  protected urlInput: HTMLInputElement
  protected showPanel = false

  constructor(overlayContainer: HTMLDivElement, public readonly name: string) {
    super(overlayContainer)
    this.overlayElement = document.createElement('div')
    this.initDom()
    this.urlInput = this.overlayElement.querySelector('.toolbar-image-url-row input') as HTMLInputElement
    this.initEvent()
  }

  public getEntryElement(): HTMLElement {
    return this.entryElement
  }

  protected initDom() {
    this.entryElement.classList.add(`toolbar-button-${this.name}`, 'toolbar-button')
    this.overlayElement.classList.add('toolbar-image-panel')
    this.overlayElement.innerHTML = imagePanelTemplate
    this.overlayContainer.appendChild(this.overlayElement)
  }

  protected initEvent() {
    this.entryElement.addEventListener('mousedown', (event) => {
      event.preventDefault()
    })
    this.overlayElement.addEventListener('mousedown', (event) => {
      if (!(event.target instanceof HTMLInputElement)) {
        event.preventDefault()
      }
    })
    this.entryElement.addEventListener('click', () => {
      if (!this.showPanel) {
        this.showOverlay()
      } else {
        this.hideOverlay()
      }
    })
    this.overlayElement.addEventListener('click', (event) => {
      const target = event.target as HTMLElement
      if (target.classList.contains('button')) {
        switch (target.dataset.name) {
          case 'done': {
            const img = new Image()
            img.onload = () => {
              this.emit('insert-image', this.urlInput.value.trim(), img.width, img.height)
            }
            img.src = this.urlInput.value.trim()
          }
          // eslint-disable-next-line no-fallthrough
          case 'close': {
            this.hideOverlay()
            break
          }
        }
      }
    })
  }

  protected showOverlay() {
    const overlayElementWidth = 286
    const entryElementHeight = 32
    const topOffset = 9
    const entryBounding = this.entryElement.getBoundingClientRect()
    const overlayContainerBounding = this.overlayContainer.getBoundingClientRect()

    this.urlInput.value = ''
    this.showPanel = true
    this.overlayElement.style.left = `${Math.max(
      Math.min(
        entryBounding.left - overlayContainerBounding.left - overlayElementWidth / 2 + entryBounding.width / 2,
        overlayContainerBounding.width - overlayElementWidth - 5,
      ),
      5,
    )}px`
    this.overlayElement.style.top = `${
      entryBounding.top - overlayContainerBounding.top + entryElementHeight + topOffset
    }px`
    this.overlayElement.style.display = 'block'
  }

  protected hideOverlay() {
    this.showPanel = false
    this.overlayElement.style.display = 'none'
  }
}
